"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroupItem = exports.RadioGroup = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var RadioGroupPrimitive = _interopRequireWildcard(require("@radix-ui/react-radio-group"));
var _server = require("@whitbread-eos/utils/server");
var _lucideReact = require("lucide-react");
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "hasError"],
  _excluded2 = ["className", "bulletFillStyle", "radioGroupButtonClass"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RadioGroup = exports.RadioGroup = React.forwardRef((_ref, ref) => {
  var {
      className,
      hasError
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _jsxRuntime.jsx)(RadioGroupPrimitive.Root, _objectSpread(_objectSpread({
    className: (0, _server.cn)('grid gap-2', hasError ? '!outline !outline-2 !outline-error !-outline-offset-2' : '', className)
  }, props), {}, {
    ref: ref
  }));
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
var RadioGroupItem = exports.RadioGroupItem = React.forwardRef((_ref2, ref) => {
  var {
      className,
      bulletFillStyle,
      radioGroupButtonClass
    } = _ref2,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return (0, _jsxRuntime.jsx)(RadioGroupPrimitive.Item, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, _server.cn)('aspect-square h-5 w-5 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', className, radioGroupButtonClass)
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)(RadioGroupPrimitive.Indicator, {
      className: "flex items-center justify-center",
      children: (0, _jsxRuntime.jsx)(_lucideReact.Circle, {
        className: (0, _server.cn)('h-2.5 w-2.5', radioGroupButtonClass ? 'fill-primaryColor' : 'fill-current', 'text-current', bulletFillStyle)
      })
    })
  }));
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;